<div class="tooltip_fullpage_overlay_wrpr" *ngIf="isVisible">
  <div class="tour_tooltip_div {{arrowClass}}" [style.top]="top" [style.left]="left">
    <div class="tour_tooltip_arrow"></div>
    <div class="tour_tooltip_header">
      <button type="button" class="close" aria-label="Close" (click)="crossClicked()">
        <span aria-hidden="true">×</span>
      </button>
      <h5>{{heading}}</h5>
    </div>
    <p>{{content}}</p>
    <div class="skip_next_btns_div" *ngIf="options.ok || options.next">
      <!-- <button class="skip_btn">Skip</button> -->
      <button *ngIf="options.ok" (click)="crossClicked()" class="next_btn">OK</button>
      <button *ngIf="options.next" (click)="crossClicked()" class="next_btn">Next</button>
    </div>
  </div>
</div>